// Hook para cargar datos de propiedad pública (sin token, sin verificación de invite)

import { useState, useEffect } from 'react';
import { getProperty } from '../services/supabaseService';

export const usePublicProperty = (propertyId) => {
  const [property, setProperty] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!propertyId) return;

    const load = async () => {
      try {
        const data = await getProperty(propertyId);
        setProperty(data);
      } catch (err) {
        console.error('Error cargando propiedad pública:', err);
        setError('LOAD_ERROR');
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [propertyId]);

  return { property, loading, error };
};
